import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import ToolPage from "./pages/ToolPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminTools from "./pages/admin/AdminTools";

export default function App() {
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tools/:slug" element={<ToolPage />} />
            </Routes>
          </Layout>
        }
      />
      {/* /admin nằm ngoài Layout công khai — không hiện nav/footer trang chính */}
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/tools" element={<AdminTools />} />
    </Routes>
  );
}
